var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-find"},[_c('h1',{staticClass:"title"},[_vm._v("Forbidden(403)")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("您没有访问权限，请联系超级管理员或开发人员，为您添加访问权限")]),_vm._v(" "),_c('button-box',{staticClass:"btn-primary",attrs:{"title":"返回首页"},on:{"click":_vm.toIndex}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a09ac318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/site/403.vue
// module id = null
// module chunks = 